import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus, FiHelpCircle, FiInfo } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    question: "When is the next Hastings Comedy Festival?",
    answer: "The next Hastings Comedy Festival is from June 1st to June 7th, 2026. Mark your calendars for a week full of laughter and fun!"
  },
  {
    question: "How can I apply to perform at the festival?",
    answer: "We love new talent! You can contact our co-directors Chris and Jake directly at Hastingscomedyfestival@yahoo.com with your bio and a link to your set."
  },
  {
    question: "Where is the Hastings Comedy Festival held?",
    answer: "The festival takes place across various venues in the beautiful seaside towns of Hastings and St Leonards-on-Sea, including The White Rock Theatre, the Jenny Lind, and many more local pubs and hubs."
  },
  {
    question: "What's the best way to buy tickets for the festival?",
    answer: "Tickets can be purchased right here on our official website. We recommend booking early as our gala shows and popular fringe events sell out fast!"
  },
  {
    question: "Time of shows",
    answer: "Showtimes vary by venue. Most fringe shows run between 6:00 PM and 10:00 PM, while our late-night club sets can go on until midnight. Check the specific event page for exact timings."
  },
  {
    question: "Are there age restrictions for Hastings Comedy Festival shows?",
    answer: "Most of our evening shows are 18+ due to venue licensing. However, we do host specific 'Family Friendly' afternoon slots. Please check the individual show details before booking."
  },
  {
    question: "What is the refund policy?",
    answer: "Tickets are generally non-refundable unless an event is cancelled or rescheduled. If you can no longer attend, you may transfer your ticket to a friend!"
  },
  {
    question: "What venues are accessible and fully accessible?",
    answer: "The White Rock Theatre is fully accessible. Many of our smaller pub venues have ground-floor access, but some may have historic constraints. Please contact us if you have specific venue accessibility questions."
  },
  {
    question: "Where can I get my hands on official Hastings Comedy Festival merch?",
    answer: "Visit our brand new online Merch Store right here on the site! We have hoodies, mugs, and limited edition prints available for delivery or festival pickup."
  }
];

const FAQItem = ({ faq, isOpen, toggle }) => (
  <div className="mb-4 border-4 border-black shadow-comic-sm overflow-hidden bg-white">
    <button 
      onClick={toggle}
      className={`w-full flex items-center justify-between p-6 text-left transition-colors ${isOpen ? 'bg-hcf-yellow' : 'hover:bg-gray-50'}`}
    >
      <span className="font-comic text-2xl text-black leading-tight">{faq.question}</span>
      <div className="bg-black text-white p-1 rounded-sm">
        <SafeIcon icon={isOpen ? FiMinus : FiPlus} />
      </div>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="border-t-4 border-black"
        >
          <div className="p-6 font-body text-xl bg-white leading-relaxed">
            {faq.answer}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <div className="text-center mb-16">
        <div className="inline-block bg-hcf-pink text-white border-4 border-black p-4 shadow-comic transform rotate-1">
          <h1 className="font-comic text-6xl">GOT QUESTIONS?</h1>
        </div>
        <div className="mt-6 flex justify-center items-center gap-3">
          <SafeIcon icon={FiHelpCircle} className="text-4xl text-hcf-cyan animate-pulse" />
          <span className="font-body text-xl font-bold uppercase tracking-widest">The Knowledge Base</span>
        </div>
      </div>

      <div className="space-y-2">
        {faqs.map((faq, index) => (
          <FAQItem 
            key={index} 
            faq={faq} 
            isOpen={openIndex === index} 
            toggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>

      {/* Extra Help Box */}
      <div className="mt-16 bg-hcf-cyan border-4 border-black p-8 shadow-comic flex items-start gap-6 transform -rotate-1">
        <div className="bg-black text-white p-4 hidden md:block">
          <SafeIcon icon={FiInfo} className="text-4xl" />
        </div>
        <div>
          <h3 className="font-comic text-3xl mb-2">STILL STUCK?</h3>
          <p className="font-body text-xl mb-4">If your question isn't answered here, drop us a line and we'll get back to you as soon as we've finished laughing.</p>
          <a href="mailto:Hastingscomedyfestival@yahoo.com" className="font-bold underline hover:text-white transition-colors">Hastingscomedyfestival@yahoo.com</a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;